var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-row",class:{
    'menu-row--divider--top': _vm.dividerTop,
    'menu-row--divider--bottom': _vm.dividerBottom,
    'menu-row--grow': _vm.grow,
  }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }